
import '@babel/polyfill'
import Application from './core'

/**
 * Bootstrap application
 *
 * Load and setup thrid party dependencies.
 */
require('./bootstrap');

/**
 * Boot application
 */
window.App = new Application()
var scrollPosition = [];
$(() => {
  if ( window.location.hash ) {
    scroll(0,0);
  }
  setTimeout( function() { 
    scroll(0,0); 
  }, 1);
  if(window.location.hash) {
    var target = $(window.location.hash);
    $('html, body').animate({
        scrollTop: target.offset().top + 'px'
    }, 800, function() {
      var $target = $(target);
      $target.focus();
      if ($target.is(":focus")) {
        return false;
      } else {
        $target.attr('tabindex','-1');
        $target.focus();
      };
    });
    history.pushState("", document.title, window.location.pathname);
  }

  $('a[href*="/#"]').not('[href="/#"]').not('[href="/#0"]').click(function(event) {
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 800, function() {
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) {
            return false;
          } else {
            $target.attr('tabindex','-1');
            $target.focus();
          };
        });
      }
    }
  });
  
  var iCurScrollPos = $(window).scrollTop();
  menuPosition(iCurScrollPos);
  menuOpacity(iCurScrollPos);
  $('#hamburgerMenu').click(function(e) {
    openHamburger();
  });

  $('#closeHamburgerMenu').click(function(e) {
    closeHamburger();
  });

  $('#overlay').click(function(e) {
    closeHamburger();
  });

  $('#nav-tab a').on('click', function (e) {
    e.preventDefault();
    removeActiveTabs();
    var id = this.dataset.id;
    $('#' + id).tab('show');
    document.getElementById(id+'-tab').classList.add('active');
    document.getElementById(id+'-tab2').classList.add('active');
    document.getElementById(id).classList.add('showing');
    $('html, body').animate({
      scrollTop: '0px'
    }, 800);
  })

  $('#nav-tab2 a').on('click', function (e) {
    e.preventDefault();
    removeActiveTabs();
    var id = this.dataset.id;
    $('#' + id).tab('show');
    document.getElementById(id+'-tab').classList.add('active');
    document.getElementById(id+'-tab2').classList.add('active');
    document.getElementById(id).classList.add('showing');
    $('html, body').animate({
      scrollTop: '0px'
    }, 800);
  })
})

function removeActiveTabs() {
  var activeTabsBTN = document.querySelectorAll('.nav-item.active');
  var activeTabs = document.querySelectorAll('.tab-pane.active');

  for (var i = 0; i < activeTabsBTN.length; i++) {
    activeTabsBTN[i].classList.remove('active');
  }

  for (var i = 0; i < activeTabs.length; i++) {
    activeTabs[i].classList.remove('active');
    activeTabs[i].classList.remove('showing');
  }
}

function openHamburger() {
  document.getElementById('hamburgerMenu').style.opacity = "0";
  document.getElementById('overlay').style.width = "100%";
  document.getElementById('overlay').style.opacity = "1";
  if($(document).width() <= 750){
    document.getElementById('offcanvas').style.width = "250px";
    document.getElementById('header').style.left = "250px";
  } else {
    document.getElementById('offcanvas').style.width = "390px";
    document.getElementById('header').style.left = "390px";
  }
  var scrollPosition = [
    self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
    self.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop
  ];
  var html = jQuery('html');
  html.data('scroll-position', scrollPosition);
  html.data('previous-overflow', html.css('overflow'));
  html.css('overflow', 'hidden');
}

function closeHamburger() {
  document.getElementById('hamburgerMenu').style.opacity = "1";
  setTimeout(function(){
    document.getElementById('overlay').style.width = "0%";
  }, 500);
  document.getElementById('overlay').style.opacity = "0";
  document.getElementById('offcanvas').style.width = "0px";
  document.getElementById('header').style.left = "0px";
  var html = jQuery('html');
  var scrollPosition = html.data('scroll-position');
  html.css('overflow', html.data('previous-overflow'));
}

var iScrollPos = 0;
$(window).scroll(function () {
  if(document.getElementById('offcanvas').style.width == "390px") {
    window.scrollTo(scrollPosition[0], scrollPosition[1]);
  }

  var iCurScrollPos = $(this).scrollTop();
  menuPosition(iCurScrollPos);
  menuOpacity(iCurScrollPos);
});

$(window).on('resize', function () {
  var iCurScrollPos = $(this).scrollTop();
  menuPosition(iCurScrollPos);
  menuOpacity(iCurScrollPos);
});

function menuOpacity(curentPos) {
  if($(document).width() <= 750) {
    if (curentPos > iScrollPos) {
      document.getElementById('header').style.opacity = "0";
    } else {
      document.getElementById('header').style.opacity = "1";
    }
    iScrollPos = curentPos;
  } else {
    if(document.getElementById("services") == null) {
      document.getElementById('header').style.opacity = "1";
    } else {
      if(curentPos > (document.getElementById("services").offsetTop-5)) {
        document.getElementById('header').style.opacity = "1";
      } else {
        document.getElementById('header').style.opacity = "0";
      }
    }
  }
}

function menuPosition(curentPos) {
  if($(document).width() > 750) {
    if(document.getElementById("services")) {
      if(curentPos > document.getElementById("services").offsetTop) {
        document.getElementById('header').style.position = 'fixed';
        document.getElementById('header').style.top = '0px';
      } else {
        document.getElementById('header').style.position = 'absolute';
        document.getElementById('header').style.top = document.getElementById("services").offsetTop+'px';
      }
    } else {
      document.getElementById('header').style.position = 'fixed';
      document.getElementById('header').style.top = '0px';
    }
  } else {
    document.getElementById('header').style.position = 'fixed';
    document.getElementById('header').style.top = '0px';
  }
}
